<template>
  <div id="contact" class="contact">
    <div class="contact-image">
      <img alt="David Cannon's photography exhibition" src="../assets/contact/print-contact.jpg"/>
    </div>
    <div class="contact-content">
      <p class="bio">
        After studying screenwriting and cinema, David launched his career as a photographer.<br>
        Since then, he shares his time between fashion, portraits and still life.
      </p>
      <p>
        David travel’s anywhere his assignments take him.
      </p>
      <hr class="separator">
      <div class="infos">
        <p>For portrait commissions, advertising and editorial assignment</p>
        <p>Fine art print editions</p>
        <p>
          <a class="contact-link" href="mailto:info@davidcannonstudio.com">info@davidcannonstudio.com</a>
        </p>
        <p class="phone-number">
          <a class="contact-link" href="tel:+15149634843">
            +1&nbsp;514&nbsp;963&nbsp;4843
          </a>
        </p>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",
  metaInfo: {
    title: "Contact"
  }
};
</script>

<style lang="scss" scoped>
.contact {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex: 1;
  width: 100%;
  margin: 0 -1.5rem;

  @media screen and (max-width: 767px) {
    display: block;
    margin: 0 auto;
  }

  > * {
    padding: 0 1.5rem;

    @media screen and (max-width: 767px) {
      padding: 0;
    }
  }

  &-image {
    width: 50%;
    min-width: 400px;
    text-align: right;
    max-width: 1000px;

    @media screen and (max-width: 767px) {
      width: 100%;
      margin-right: 0;
      margin-bottom: 2rem;
      min-width: unset;
      max-width: unset;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 700px;

    .bio {
      line-height: 1.5;
    }

    .separator {
      width: 1.75rem;
      text-align: left;
      margin: 1.5rem 0;
      border-width: 1px 0 0 0;
    }

    .infos {
      .contact-link {
        text-decoration: none;
        cursor: pointer;

        &:hover {
          color: #9e9e9e;
        }
      }
    }

    p:not(:last-of-type) {
      margin-bottom: 0.875rem;
    }
  }
}
</style>
